import ctaimage from "../../../../images/LandingPageImage/send_bulk_message_cta.webp";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import MyContext from "../../../../MyContext";

export default function CallToAction() {
  const { openFreeTrialModal } = useContext(MyContext);

  return (
    <section
      className="py-5 font-inter"
      style={{ background: "linear-gradient(to top, #02151B, #088757)" }}
    >
      <div className="container px-3 px-md-0">
        <div
          className="mx-auto overflow-hidden p-4 p-sm-5 rounded-4"
          style={{
            maxWidth: "1024px",
            background:
              "linear-gradient(to left, rgba(34, 125, 83, 0), rgba(34, 125, 83, 0.87))",
          }}
        >
          <div className="row align-items-center g-4 g-md-5">
            <div className="col-12 col-md-6">
              <div
                className="d-inline-block border border-white border-opacity-25 shadow-sm rounded-pill py-2 px-4 mb-4"
                style={{ backgroundColor: "rgba(0, 50, 0, 0.1)" }}
              >
                <p className="m-0 text-white fw-medium">Get Started Now</p>
              </div>

              <h2
                className="display-6 fw-semibold text-white mb-4 lh-base"
                style={{ fontSize: "calc(1.3rem + 0.6vw)" }}
              >
                Chat with SleekFlow AI agent, created with pride using AgentFlow
              </h2>

              <div className="d-flex flex-column flex-sm-row align-content-center gap-3 mt-4">
                <button
                  onClick={openFreeTrialModal}
                  className="btn btn-outline-google text-dark-green  rounded-pill fw-semibold d-flex align-items-center justify-content-center gap-2 px-2 px-sm-3 py-1 w-sm-auto"
                  style={{ minHeight: "40px" }}
                >
                  <span className="text-nowrap">Start Free Trial</span>
                </button>

                <Link to="/pricing_details" className="text-decoration-none">
                  <button
                    type="button"
                    className="btn btn-outline-google text-dark-green  rounded-pill fw-semibold d-flex align-items-center justify-content-center gap-2 px-2 px-sm-3 py-1 w-sm-auto"
                    style={{ minHeight: "40px" }}
                  >
                    <span className="text-nowrap">See Pricing</span>
                  </button>
                </Link>
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className="w-100" style={{ height: "320px" }}>
                <img
                  src={ctaimage}
                  alt="feature"
                  className="w-100 h-100 object-fit-contain rounded-3"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
